import { NumericFormat } from 'react-number-format';
import { Controller, useFormContext } from 'react-hook-form';
import { WrapperInputField } from '@shared/InputField/styles';
import { ConfidenceLevel } from '@domains/documents-review/hooks/useFieldConfidence';
import { withRequiredMark } from '@shared/utils/fieldLabel';

interface PriceInputProps {
  label: string;
  name: string;
  required?: boolean;
  placeholder?: string;
  confidenceLevel?: ConfidenceLevel;
  confidenceBorderColor?: string;
  confidenceBoxShadow?: string;
  onFieldEdit?: (fieldName: string) => void;
}

export const PriceInputField = ({
  label,
  name,
  required = false,
  placeholder = 'Escribir',
  confidenceLevel,
  confidenceBorderColor,
  confidenceBoxShadow,
  onFieldEdit,
}: PriceInputProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const confidenceStyle =
    confidenceLevel && confidenceBorderColor && confidenceBoxShadow
      ? {
          border: `1px solid ${confidenceBorderColor}`,
          boxShadow: confidenceBoxShadow,
        }
      : {};

  const isDisabled = confidenceLevel === 'HIGH';

  return (
    <WrapperInputField>
      <label htmlFor={name}>{withRequiredMark(label, required)}</label>
      <Controller
        name={name}
        control={control}
        rules={required ? { required: 'Campo requerido' } : {}}
        render={({ field: { onChange, value } }) => (
          <NumericFormat
            id={name}
            value={value ?? ''}
            thousandSeparator="."
            decimalSeparator=","
            prefix="$ "
            allowNegative={false}
            placeholder={placeholder}
            onValueChange={values => {
              // Call the onFieldEdit callback when user edits
              if (onFieldEdit) {
                onFieldEdit(name);
              }
              // Call original onChange
              onChange(values.value);
            }}
            style={confidenceStyle}
            disabled={isDisabled}
          />
        )}
      />
      {errors[name] && (
        <small className="text-danger my-1 fw-bold">
          {errors[name]?.message as string}
        </small>
      )}
    </WrapperInputField>
  );
};
